import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ADS_NOTICE_TEXT, getOpenAIAdsChoice, requiresAdvertisingConsent, saveOpenAIAdsChoice } from "@/lib/openaiAdsPrivacy";

export function OpenAIAdsConsent({ excluded }: { excluded: boolean }) {
  const [visible, setVisible] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    const sync = async () => {
      const choice = await getOpenAIAdsChoice();
      if (active) setVisible(requiresAdvertisingConsent(choice.region) && choice.advertising === "unanswered");
    };
    const open = () => setVisible(true);
    void sync();
    window.addEventListener("storage", sync);
    window.addEventListener("openai-ads-choice-change", sync);
    window.addEventListener("openai-ads-settings-open", open);
    return () => { active = false; window.removeEventListener("storage", sync); window.removeEventListener("openai-ads-choice-change", sync); window.removeEventListener("openai-ads-settings-open", open); };
  }, []);
  const choose = async (value: "accepted" | "denied") => {
    setSaving(true);
    try { await saveOpenAIAdsChoice(value); setVisible(false); setError(false); }
    catch { setError(true); }
    finally { setSaving(false); }
  };
  if (excluded) return null;
  if (!visible) return <Button variant="outline" size="sm" className="fixed bottom-20 left-3 z-[100] shadow-lg" onClick={() => setVisible(true)}>Advertising settings</Button>;
  return (
    <section role="dialog" aria-modal="false" aria-labelledby="advertising-consent-title" className="fixed bottom-0 inset-x-0 z-[100] border-t border-border bg-background text-foreground shadow-lg max-h-[80vh] overflow-y-auto">
      <div className="mx-auto max-w-6xl p-5 sm:p-6 flex flex-col lg:flex-row gap-5 lg:items-center">
        <div className="flex-1">
          <h2 id="advertising-consent-title" className="text-lg font-semibold mb-2">Your advertising privacy</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">{ADS_NOTICE_TEXT}</p>
          <Link to="/privacy#cookies" className="text-sm text-primary underline inline-block mt-2">Privacy Policy</Link>
          {error && <p role="alert" className="text-sm text-destructive mt-2">Your choice could not be saved. Advertising remains blocked until a choice is saved.</p>}
        </div>
        <div className="grid grid-cols-2 gap-3 shrink-0">
          <Button variant="outline" disabled={saving} onClick={() => void choose("denied")}>Reject advertising</Button>
          <Button variant="outline" disabled={saving} onClick={() => void choose("accepted")}>Accept advertising</Button>
        </div>
      </div>
    </section>
  );
}